import React from "react";

/**
 * @param props
 * @param props.title
 */
export default function MetaTitle({ title }) {
  React.useLayoutEffect(() => {
    document.title = "Conforce Track | " + title;
  }, [title]);

  return null;
}
